import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  category: '',
  deploymentType: '',
  productType: '',
  tenantType: '',
  domain: '',
  emailId: '',
};

const slice = createSlice({
  name: 'tenantDetails',
  initialState,
  reducers: {
    setCategory(state, action) {
      state.category = action.payload.category;
    },
    setDeploymentType(state, action) {
      state.deploymentType = action.payload.deploymentType;
    },
    setProductType(state, action) {
      state.productType = action.payload.productType;
    },
    setTenantType(state, action) {
      state.tenantType = action.payload.tenantType;
    },
    setDomain(state, action) {
      state.domain = action.payload.domain;
    },
    setEmailId(state, action) {
      state.emailId = action.payload.emailId;
    },
  },
});

const tenantDetailsSlice = {
  initialState,
  reducers: {
    [slice.name]: slice.reducer,
  },
  actions: slice.actions,
  select: {
    category: (state) => state[slice.name].category,
    deploymentType: (state) => state[slice.name].deploymentType,
    productType: (state) => state[slice.name].productType,
    tenantType: (state) => state[slice.name].tenantType,
    domain: (state) => state[slice.name].domain,
    emailId: (state) => state[slice.name].emailId,
  },
  rememberedKeys: [],
};

export default tenantDetailsSlice;
